import {Attribute} from "types/Attribute";
import {dateTime} from "services/date";

/**
 * Transform the given attribute by deserializing object properties
 *
 * @internal
 * @param attribute
 */
export default function deserializeAttribute(attribute: any): Attribute {
  attribute.created_at = dateTime(attribute.created_at)
  attribute.updated_at = dateTime(attribute.updated_at)

  return attribute;
}